import { forwardRef } from "react";

import { Box, StackProps, Stack, useTheme } from "@mui/material";

import { mergeSx } from "@/helpers/mergeSx";

export type StorybookDialogPreviewProps = StackProps;

export const StorybookDialogPreview = forwardRef<HTMLDivElement, StorybookDialogPreviewProps>(
  ({ sx, children, ...rest }, ref) => {
    const theme = useTheme();

    return (
      <Box sx={{ padding: { xs: 2, md: 4 }, backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
        <Stack
          ref={ref}
          {...rest}
          sx={mergeSx(
            {
              maxWidth: 600,
              maxHeight: 600,
              marginInline: "auto",
              backgroundColor: theme.palette.formsComponents.dialog.backgroundColor,
              borderRadius: theme.radius(1),
              boxShadow: theme.shadows[8],
            },
            sx
          )}
        >
          {children}
        </Stack>
      </Box>
    );
  }
);

StorybookDialogPreview.displayName = "StorybookDialogPreview";
